import { render, staticRenderFns } from "./addGzh.vue?vue&type=template&id=73152f60&scoped=true&"
import script from "./addGzh.vue?vue&type=script&lang=js&"
export * from "./addGzh.vue?vue&type=script&lang=js&"
import style0 from "./addGzh.vue?vue&type=style&index=0&id=73152f60&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73152f60",
  null
  
)

export default component.exports